import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import SEO from '../components/SEO';
import '../css/LoginPage.css'; // Додамо стилі пізніше
import { BACKEND_URL } from '../config';

const LoginPage = () => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false); // Додаємо стан завантаження
    const navigate = useNavigate();
    const location = useLocation();

    // Визначаємо, куди перенаправити після успішного логіну
    // Переконуємось, що шлях відповідає захищеному маршруту
    const from = location.state?.from?.pathname || "/room-for-big-guys-qmttydsra-53231998";

    const handleLogin = async (e) => {
        e.preventDefault();
        setError('');
        setLoading(true);

        try {
            // Вказуємо ПОВНУ URL бекенду
            const response = await fetch(`${BACKEND_URL}/api/auth/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ login: username, password: password }),
            });

            if (!response.ok) {
                let errorMessage = `Помилка ${response.status}`;
                try {
                    // Спробуємо отримати помилку з JwtResponse або стандартного повідомлення
                    const errorData = await response.json();
                    errorMessage = errorData.message || errorData.error || JSON.stringify(errorData) || errorMessage;
                } catch (parseError) {
                    errorMessage = `Помилка ${response.status}: ${response.statusText || 'Не вдалося отримати дані помилки'}`;
                }
                throw new Error(errorMessage);
            }

            // Очікуємо відповідь типу { "token": "..." } (з JwtResponse)
            const data = await response.json();

            if (data.token) {
                console.log('Login successful, token received');
                localStorage.setItem('authToken', data.token);
                navigate(from, { replace: true });
            } else {
                throw new Error('Токен не отримано від сервера');
            }

        } catch (err) {
            console.error("Login failed:", err);
            setError(err.message || 'Помилка входу. Спробуйте ще раз.');
            localStorage.removeItem('authToken');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-page">
            <SEO
                title="Вхід для адміністратора"
                description="Адміністративна панель UnionAuto - вхід"
                noindex={true}
            />
            <div className="login-container">
                <h2>Вхід для адміністратора</h2>
                <form onSubmit={handleLogin}>
                    <div className="form-group">
                        <label htmlFor="username">Логін</label>
                        <input
                            type="text"
                            id="username" // залишаємо id для label
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            required
                            autoComplete="username"
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Пароль</label>
                        <input
                            type="password"
                            id="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                            autoComplete="current-password"
                        />
                    </div>
                    {error && <p className="error-message">{error}</p>}
                    <button type="submit" className="login-button" disabled={loading}>
                        {loading ? 'Вхід...' : 'Увійти'}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default LoginPage; 